export function sortByCode<T extends { code?: string }>(
  elA: T,
  elB: T,
): number {
  if (!elA.code) {
    return 1;
  }

  if (!elB.code) {
    return -1;
  }

  return elA.code.localeCompare(elB.code, undefined, {
    numeric: true,
  });
}
